module.exports = __webpack_public_path__ + "img/network.de558fd4.svg";